export enum NOTIFICATION_IDS {
  AUTHENTICATION = "AUTHENTICATION",
  RESET_PASSWORD = "RESET_PASSWORD",
}
